var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderList",staticStyle:{"padding":"20px"}},[_c('Table',{attrs:{"columns":_vm.columns12,"height":"500","highlight-row":true,"stripe":true,"data":_vm.orderList},on:{"on-row-click":_vm.toInfo},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var row = ref.row;
return [_c('strong',[_vm._v(_vm._s(row.userNames))])]}},{key:"positionName",fn:function(ref){
var row = ref.row;
return [_c('strong',[_vm._v(_vm._s(row.position))])]}},{key:"bookYear",fn:function(ref){
var row = ref.row;
return [_vm._v("\n            "+_vm._s(row.year)+"年"+_vm._s(row.month)+"月\n        ")]}},{key:"statusName",fn:function(ref){
var row = ref.row;
return [_c('strong',{style:({color:_vm.checkCls(row.status)})},[_vm._v(_vm._s(row.statusName))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }